export enum ViewEnum {
	Compact = 'compact',
	Detailed = 'detailed',
	Grid = 'grid',
}
export type ViewType = ViewEnum;
